import { observer } from 'mobx-react';
import React from 'react';
import MapBlock from './MapBlock';

@observer
class MapCorridor extends React.Component {
  render() {
    const { corridor } = this.props;
    return <div className="map__corridor" >{corridor.Blocks.map((block, blockIndex) => {
      return <MapBlock key={blockIndex} block={block} direction={corridor.Direction} />
    })}</div>
  }
}

export default MapCorridor;